module.exports = __webpack_public_path__ + "fontawesome-webfont.svg";


//////////////////
// WEBPACK FOOTER
// /home/xpro/Documentos/ances/myjangular/src/styles/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../src/styles/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = styles